import React from 'react';
import LogoTypeRender from './LogoTypeRender';

export const LogoType = ():JSX.Element=>{
	return <LogoTypeRender/>;
};